import React, { useState, useEffect } from 'react'
import { Panel, Row, Form, Col, RadioGroup, Radio, Checkbox, CheckboxGroup } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import { isValidators } from '../../utils/ValidatorUtils'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { downloadFileByPath, getDownloadAttachmentGrantee } from '../../redux/actions/contract'
import { doneLoading, startLoading } from '../../utils/loading'
import CenterChangeFormAttach from './CenterChangeFormAttach'
import CenterChangeFormContractCenterAttach from './CenterChangeFormContractCenterAttach'

export default function CenterChangeFormForm({
  schema: _schema,
  attachFiles,
  attachForm,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSelectOption = () => {},
  setTableSelected = () => {},
  // gettableSelected = [],
  onDeleteFile = () => {},
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [isEContract, setIsEContract] = useState(props?.isEContract)
  const [optionSelected, setOptionSelected] = useState(schema?.saveContractChange?.value || '1')

  const projectId = sessionStorage.getItem('projectId')

  const onDownload = async (fileObj) => {
    startLoading()

    var file = await downloadFileByPath(fileObj.path)
    //var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)
    downloadFile(file, fileObj.name)

    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()

    var file = await downloadFileByPath(fileObj.path)
    //var file = await getDownloadAttachmentGrantee(projectId, fileObj.id)

    previewFile(file, fileObj.name)
    doneLoading()
  }

  const onAddOrDelFile = (data) => {
    setValue('contractorFile', data)
  }

  return (
    <>
      <Form>
        <Controller name={'contractorFile'} control={control} defaultValue={[]} />
        <Panel>
          <Row>
            {schema.saveContractChange && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <Controller
                  name={schema.saveContractChange.name}
                  control={control}
                  defaultValue={optionSelected}
                  rule={register(isValidators(schema.saveContractChange.validators))}
                  render={(props) => {
                    return (
                      <RadioGroup
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          // onSelect(value)
                          setOptionSelected(value)
                          onSelectOption(value)
                        }}
                      >
                        {schema.saveContractChange.options.map((item) => (
                          <Radio key={item.value} value={item.value}>
                            {item.label}
                          </Radio>
                        ))}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 10 }}>
            {/* {schema.signType && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <InputSelectForm
                  schema={schema.signType}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  searchable={false}
                  onChange={(value) => {
                    setIsEContract(value == 2)
                  }}
                />
              </Col>
            )} */}

            {optionSelected != 1 && (
              <>
                {optionSelected != 4 && (
                  <>
                    {schema.reqFileContractChange && (
                      <>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <b>{schema.reqFileContractChange.label}</b>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div style={{ marginTop: 10 }}>
                            {/* <Checkbox> Default</Checkbox> */}
                            <Controller
                              key={schema.reqFileContractChange.name}
                              name={schema.reqFileContractChange.name}
                              control={control}
                              rules={isValidators(schema.reqFileContractChange.validators)}
                              defaultValue={schema.reqFileContractChange.value}
                              render={(props) => {
                                return (
                                  <CheckboxGroup
                                    // inline
                                    // name={schema.reqFileContractChange.name}
                                    value={props.value || []}
                                    onChange={(value, checked, e) => {
                                      // console.log('checked => ', value)
                                      props.onChange(value)
                                    }}
                                  >
                                    {schema.reqFileContractChange.options.map((item) => {
                                      if (item.value != 3) {
                                        return (
                                          <Checkbox value={item.value} key={item.value}>
                                            {item.label}
                                          </Checkbox>
                                        )
                                      }
                                    })}
                                  </CheckboxGroup>
                                )
                              }}
                            />
                          </div>
                        </Col>

                        {attachFiles && (
                          <Col xs={24} sm={24} md={24} lg={24}>
                            <CenterChangeFormAttach
                              attachFiles={attachFiles}
                              setTableSelected={setTableSelected}
                              onDownload={onDownload}
                              onPreview={onPreview}
                              forceSelected={attachFiles.forceSelected || []}
                            />
                          </Col>
                        )}

                        {attachForm && (
                          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 20 }}>
                            <CenterChangeFormContractCenterAttach
                              // schema={schema}
                              schema={attachForm}
                              onDownload={onDownload}
                              onPreview={onPreview}
                              onDelete={onDeleteFile}
                              onAddOrDelFile={onAddOrDelFile}
                            />
                          </Col>
                        )}
                      </>
                    )}
                  </>
                )}

                {schema.note && (
                  <Col xs={24} sm={24} md={24} lg={24}>
                    {/* <ReactQuillFrom
                   schema={schema.note}
                   toolbar={[]}
                   register={register}
                   Controller={Controller}
                   control={control}
                   errors={errors}
                   setValue={setValue}
                   clearErrors={clearErrors}
                   toolbars={[['bold', 'italic', 'underline']]}
                 /> */}
                    <CKEditorFrom
                      schema={schema.note}
                      //toolbar={[]}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                )}

                {optionSelected == 2 && (
                  <>
                    {schema.witness1 && (
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <InputSelectForm
                          schema={schema.witness1}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                        />
                      </Col>
                    )}

                    {schema.witness2 && (
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <InputForm
                          schema={schema.witness2}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                        />
                      </Col>
                    )}
                  </>
                )}
              </>
            )}
          </Row>
        </Panel>
      </Form>
    </>
  )
}
